import { NavListItem, NavListSectionHeader } from "#root/components/nav-list";
import type { ReactNode } from "react";
import { Fragment } from "react";
import { MdEdit } from "react-icons/md";
import { NavLink, useParams } from "react-router-dom";
import Layout from "../layout";

export default function (props: Parameters<typeof Layout>["0"]): ReactNode {
  const { feedId } = useParams();

  return (
    <Layout
      {...props}
      feedElements={
        feedId ? (
          <Fragment>
            <NavListSectionHeader>Feed NF-{feedId}</NavListSectionHeader>
            <NavLink to={`/admin/platform/newsrpm-parser/feed/${feedId}/edit`}>
              <NavListItem icon={MdEdit}>Edit</NavListItem>
            </NavLink>
          </Fragment>
        ) : undefined
      }
    />
  );
}
